import React, { useMemo } from 'react';
import IntensityPanel from './IntensityPanel';
import { useTranslation } from 'react-i18next';
import { getColorByPercentage } from '../../utils/colorUtils';

interface NumberPanelProps {
  number?: number;
  variant?: 'primary' | 'small' | 'result';
  className?: string;
  maxNumber?: number;
}

const NumberPanel: React.FC<NumberPanelProps> = ({ 
  number = 0, 
  variant = 'primary', 
  className = '',
  maxNumber = 9 
}) => {
  const { t } = useTranslation();
  const color = useMemo(() => {
    const percentage = (number - 1)/(maxNumber-1) * 100
    const color = getColorByPercentage("#4ade80", "#ef4444", percentage)
    console.log(color)
    return color
  }, [number, maxNumber])
  if (variant === 'primary') {
    return (
      <div className={`text-white p-8 rounded-xl text-center shadow-lg w-full ${className}`} style={{backgroundColor: color}}>
        <div className="bg-white text-orange-500 rounded-full w-32 h-32 flex items-center justify-center mx-auto mb-4 shadow-lg">
          <span className="text-6xl font-black">
            {number || "?"}
          </span>
        </div>
        
        <IntensityPanel number={number} maxNumber={maxNumber} />
      </div>
    );
  }

  if (variant === 'small') {
    return (
      <div className={`inline-flex items-center justify-center w-16 h-16 bg-yellow-400 text-white text-2xl font-bold rounded-full border-4 border-yellow-300 shadow-lg ${className}`}>
        {number}
      </div>
    );
  }

  if (variant === 'result') {
    return (
      <div className={`bg-yellow-50 border-2 border-yellow-200 rounded-xl p-4 text-center ${className}`}>
        <h4 className="text-lg font-semibold text-yellow-800 mb-2">
          {t('game.yourNumberWas')}
        </h4>
        <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-400 text-white text-2xl font-bold rounded-full border-4 border-yellow-300 shadow-lg">
          {number}
        </div>
      </div>
    );
  }

  return null;
};

export default NumberPanel;